// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import GroupSelectorController from "./group_selector_controller"
application.register("group-selector", GroupSelectorController)

import ModalSelectController from "./modal_select_controller"
application.register("modal-select", ModalSelectController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)
